import { OnDestroy } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { LogManager } from "../../log/log.manager";
import { takeUntilDestroy } from "take-until-destroy";
import { LogCat } from "../../log/log.categories";
import * as i0 from "@angular/core";
import * as i1 from "./version.details.proxy";
var VersionDetailsService = /** @class */ (function () {
    function VersionDetailsService(versionDetailsProxy) {
        this.versionDetailsProxy = versionDetailsProxy;
        this.defaultVersion = "11.5.0.0";
        this.defaultProductLabelingState = "RNMD";
        this.subject = new BehaviorSubject(null);
    }
    VersionDetailsService.prototype.ngOnDestroy = function () { };
    VersionDetailsService.prototype.load = function () {
        var _this = this;
        this.versionDetailsProxy.getVersionDetails()
            .pipe(takeUntilDestroy(this))
            .subscribe(function (result) {
            var versionDetails = {
                buildDate: new Date(result.buildDate),
                commercialVersion: result.commercialVersion,
                internalVersion: result.internalVersion,
                productLabelingState: result.productLabelingState
            };
            _this.subject.next(versionDetails);
        }, function (e) {
            LogManager.error(LogCat.Login.VersionDetails, "Failed to get server version details taking default values", e);
            // Take the current datetime
            var buildDate = new Date();
            var versionDetails = {
                buildDate: buildDate,
                commercialVersion: _this.defaultVersion,
                internalVersion: _this.defaultVersion,
                productLabelingState: _this.defaultProductLabelingState
            };
            _this.subject.next(versionDetails);
        });
        return this.subject.asObservable();
    };
    VersionDetailsService.prototype.getVersionDetails = function () {
        return this.subject.getValue();
    };
    VersionDetailsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VersionDetailsService_Factory() { return new VersionDetailsService(i0.ɵɵinject(i1.VersionDetailsProxy)); }, token: VersionDetailsService, providedIn: "root" });
    return VersionDetailsService;
}());
export { VersionDetailsService };
